<template>
  <BDLayout>
    <div class="transaction">
      <section id="bd-clients">
        <div class="container">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="fw-bold mb-0">Clients</h6>
            <button class="btn btn-primary btn-sm" @click="showAddForm = !showAddForm">{{ showAddForm ? 'Close' : 'Add Client' }}</button>
          </div>

          <div v-show="showAddForm" class="card mb-3 p-3">
            <div class="row g-2 align-items-end">
              <div class="col-md-4">
                <label class="form-label">Client Name</label>
                <input v-model="form.name" type="text" class="form-control" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Country</label>
                <select v-model="form.country" class="form-control">
                  <option value="">Select country</option>
                  <option v-for="c in countries" :key="c.id" :value="c.name">{{ c.name }}</option>
                </select>
                <!--<div class="d-flex mt-1">
                  <input
                    v-model="newCountry"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Add country"
                  />
                  <button
                    class="btn btn-sm btn-outline-primary ms-1"
                    type="button"
                    @click="addCountry"
                  >
                    Add
                  </button>
                </div>-->
              </div>
              <div class="col-md-3">
                <label class="form-label">Sector</label>
                <select v-model="form.sectorId" class="form-control">
                  <option value="">Select sector</option>
                  <option v-for="s in sectors" :key="s.id" :value="s.id">{{ s.name }}</option>
                </select>
              </div>
              <div class="col-md-2 d-flex justify-content-end">
                <button class="btn btn-primary w-100" @click="saveClient" :disabled="saving">
                  <span v-if="!saving">{{ editing ? 'Update Client' : 'Add Client' }}</span>
                  <span v-else>Saving...</span>
                </button>
              </div>
            </div>
          </div>

          <!-- Summary cards -->
          <div class="row g-3 mb-3" v-if="clients.length">
            <div class="col-md-3 col-sm-6">
              <div class="card shadow-sm border-0 h-100 bd-fade-in bd-card-lift">
                <div class="card-body py-3">
                  <div class="text-muted small">Total Clients</div>
                  <div class="h4 mb-0">{{ totalClients }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="card shadow-sm border-0 h-100 bd-fade-in bd-card-lift">
                <div class="card-body py-3">
                  <div class="text-muted small">Total Opportunities</div>
                  <div class="h4 mb-0">{{ totalOpportunities }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="card shadow-sm border-0 h-100 bd-fade-in bd-card-lift">
                <div class="card-body py-3">
                  <div class="text-muted small">Total Contracts</div>
                  <div class="h4 mb-0">{{ totalContracts }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="card shadow-sm border-0 h-100 bd-fade-in bd-card-lift">
                <div class="card-body py-3">
                  <div class="text-muted small">Clients with Active Contract</div>
                  <div class="h4 mb-0">{{ clientsWithActiveContract }}</div>
                </div>
              </div>
            </div>
          </div>

            <div class="products-list transaction-products-list bd-fade-in" style="margin-top: 0;">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="fw-bold mb-0">Clients</h6>
                <div class="position-relative">
                  <button class="btn btn-sm btn-style-2 bd-btn-scale" @click="showFilters = !showFilters">Filters</button>
                  <div v-if="showFilters" class="filter-popover card p-3">
                    <div class="mb-2">
                      <label class="form-label">Search</label>
                      <input v-model="filters.search" class="form-control form-control-sm" placeholder="Client name..." />
                    </div>
                    <div class="mb-2">
                      <label class="form-label">Country</label>
                      <select v-model="filters.country" class="form-control form-control-sm">
                        <option value="">All</option>
                        <option v-for="c in countries" :key="c.id" :value="c.name">{{ c.name }}</option>
                      </select>
                    </div>
                    <div class="mb-2">
                      <label class="form-label">Sector</label>
                      <select v-model="filters.sectorId" class="form-control form-control-sm">
                        <option value="">All</option>
                        <option v-for="s in sectors" :key="s.id" :value="s.id">{{ s.name }}</option>
                      </select>
                    </div>
                    <div class="mb-2">
                      <label class="form-label">Has Active Contract</label>
                      <select v-model="filters.hasActive" class="form-control form-control-sm">
                        <option value="">All</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                    <div class="row g-2">
                      <div class="col-6">
                        <label class="form-label">Start Date</label>
                        <input type="date" v-model="filters.startDate" class="form-control form-control-sm" />
                      </div>
                      <div class="col-6">
                        <label class="form-label">End Date</label>
                        <input type="date" v-model="filters.endDate" class="form-control form-control-sm" />
                      </div>
                    </div>
                    <div class="mb-2 mt-2">
                      <label class="form-label">Min Contracts</label>
                      <input type="number" v-model="filters.minContracts" class="form-control form-control-sm" placeholder="0" />
                    </div>
                    <div class="d-flex justify-content-between mt-2">
                      <button class="btn btn-sm btn-secondary" @click="resetFilters">Reset</button>
                      <button class="btn btn-sm btn-primary" @click="applyFilters">Filter</button>
                    </div>
                  </div>
                </div>
              </div>

            <SkeletonLoader v-if="loading" type="table" :rows="6" :columns="9" />

            <table
              id="clientsTable"
              ref="clientsTable"
              class="table table-sm table-hover mb-0"
              v-else-if="clients.length"
            >
              <thead>
                <tr>
                  <th style="width: 48px;">#</th>
                  <th>Client</th>
                  <th>Country</th>
                  <th>Sector</th>
                  <th>Opportunities</th>
                  <th>Losses</th>
                  <th>Contracts</th>
                  <th>Has Active Contract?</th>
                  <th style="width: 80px;">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(c, idx) in clients" :key="c.id">
                  <td>{{ idx + 1 }}</td>
                  <td>{{ c.name }}</td>
                  <td>{{ c.country }}</td>
                  <td>{{ c.sector?.name }}</td>
                  <td>{{ c.opportunitiesCount ?? 0 }}</td>
                  <td>{{ c.lossesCount ?? 0 }}</td>
                  <td>{{ c.contractsCount ?? 0 }}</td>
                  <td>
                    <span v-if="c.hasActiveContract">Yes</span>
                    <span v-else>No</span>
                  </td>
                  <td>
                    <div class="btn-group btn-group-sm" role="group">
                      <button class="btn btn-sm btn-style-2 bd-btn-scale" @click="startEdit(c)">Edit</button>
                      <router-link
                        class="btn btn-sm btn-outline-info bd-btn-scale"
                        :to="{ name: 'BidClientDetail', params: { id: c.id } }"
                      >View</router-link>
                      <button class="btn btn-sm btn-outline-danger bd-btn-scale" @click="deleteClient(c)">Delete</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <p v-else class="text-muted mb-0">No clients found.</p>
          </div>

        </div>
      </section>
    </div>
  </BDLayout>
</template>

<script>
import { ref, reactive, onMounted, nextTick, computed, onBeforeUnmount } from 'vue'
import BDLayout from '@/components/BDLayout.vue'
import SkeletonLoader from '@/components/SkeletonLoader.vue'
import { bidApi } from '@/api/bid'
import $ from 'jquery'
import 'datatables.net-vue3'
import 'datatables.net-bs5'
import 'datatables.net-buttons-bs5'
import 'datatables.net-responsive-bs5'
import 'jszip'
import 'datatables.net-buttons/js/buttons.html5.js'
import 'datatables.net-buttons/js/buttons.colVis.js'
import 'datatables.net-buttons/js/buttons.print.js'
import Swal from 'sweetalert2'

export default {
  name: 'BidClients',
  components: { BDLayout, SkeletonLoader },
  setup() {
    const clients = ref([])
    const originalClients = ref([])
    const saving = ref(false)
    const loading = ref(false)
    const countries = ref([])
    const sectors = ref([])
    // eslint-disable-next-line no-unused-vars
    const showAddForm = ref(false)
    const clientsTable = ref(null)
    let dataTable = null
    const editing = ref(false)
    const editingId = ref(null)
    const form = reactive({
      name: '',
      country: '',
      sectorId: '',
    })
    const newCountry = ref('')

    const loadClients = async () => {
      loading.value = true
      try {
        const list = await bidApi.listClients()
        clients.value = list
        originalClients.value = Array.isArray(list) ? list : (list.data || [])
        await nextTick()
        // initialize DataTable after a short delay to ensure DOM and styles are ready
        setTimeout(() => initializeDataTable(), 50)
      } catch (err) {
        console.error('Failed to load clients', err)
      } finally {
        loading.value = false
      }
    }

    const loadCountries = async () => {
      try {
        const base = (process.env.VUE_APP_URL || 'http://localhost:3000').replace(/\/+$/, '')
        const res = await fetch(base + '/countries', {
          headers: {
            Accept: 'application/json',
            ...(localStorage.getItem('access_token')
              ? { Authorization: `Bearer ${JSON.parse(localStorage.getItem('access_token'))}` }
              : {}),
          },
        })
        if (!res.ok) return
        const data = await res.json()
        const list = data && typeof data === 'object' && (data.data || data.items || data.rows)
          ? data.data || data.items || data.rows
          : data
        countries.value = Array.isArray(list) ? list : []
      } catch (err) {
        console.error('Failed to load countries', err)
      }
    }

    const loadSectors = async () => {
      try {
        const base = (process.env.VUE_APP_URL || 'http://localhost:3000').replace(/\/+$/, '')
        const res = await fetch(base + '/sectors', {
          headers: {
            Accept: 'application/json',
            ...(localStorage.getItem('access_token')
              ? { Authorization: `Bearer ${JSON.parse(localStorage.getItem('access_token'))}` }
              : {}),
          },
        })
        if (!res.ok) return
        const data = await res.json()
        const list = data && typeof data === 'object' && (data.data || data.items || data.rows)
          ? data.data || data.items || data.rows
          : data
        sectors.value = Array.isArray(list) ? list : []
      } catch (err) {
        console.error('Failed to load sectors', err)
      }
    }

    const resetForm = () => {
      form.name = ''
      form.country = ''
      form.sectorId = ''
    }

    const initializeDataTable = () => {
      try {
        if (!clientsTable.value) return

        if (dataTable) {
          dataTable.destroy()
          dataTable = null
        }

        dataTable = $(clientsTable.value).DataTable({
          dom: 'Bfrtip',
          responsive: true,
          language: {
            paginate: {
              previous: '<i class="fas fa-chevron-left"></i>',
              next: '<i class="fas fa-chevron-right"></i>',
            },
          },
          buttons: [
            'colvis',
            'pageLength',
            {
              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-primary btn-sm',
              exportOptions: {
                columns: ':visible:not(:last-child)',
              },
            },
            {
              extend: 'excel',
              text: 'Export Excel',
              className: 'btn btn-primary btn-sm',
              exportOptions: {
                columns: ':visible:not(:last-child)',
              },
            },
            {
              extend: 'print',
              text: 'Print',
              className: 'btn btn-secondary btn-sm',
              exportOptions: {
                columns: ':visible:not(:last-child)',
              },
            },
          ],
        })
      } catch (error) {
        console.error('Failed to initialize DataTable', error)
      }
    }

    const saveClient = async () => {
      if (!form.name || !form.country) return
      saving.value = true
      try {
        const baseUrl = (process.env.VUE_APP_URL || 'http://localhost:3000').replace(/\/+$/, '')
        const url = editing.value && editingId.value
          ? `${baseUrl}/clients/${editingId.value}`
          : `${baseUrl}/clients`
        const method = editing.value && editingId.value ? 'PATCH' : 'POST'
        const res = await fetch(url, {
          method,
          headers: {
            'Content-Type': 'application/json',
            ...(localStorage.getItem('access_token')
              ? { Authorization: `Bearer ${JSON.parse(localStorage.getItem('access_token'))}` }
              : {}),
          },
          body: JSON.stringify({
            name: form.name,
            country: form.country,
            sectorId: form.sectorId || null,
          }),
        })
        const data = await res.json()
        if (data && data.status) {
          resetForm()
          editing.value = false
          editingId.value = null
          await loadClients()
        } else {
          console.error('Failed to create client', data)
        }
      } catch (err) {
        console.error('Failed to create client', err)
      } finally {
        saving.value = false
      }
    }

    const startEdit = (client) => {
      editing.value = true
      editingId.value = client.id
      form.name = client.name
      form.country = client.country
      form.sectorId = client.sectorId || (client.sector && client.sector.id) || ''
    }

    const deleteClient = async (client) => {
      const result = await Swal.fire({
        title: 'Delete client?',
        text: `Delete client "${client.name}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#d33',
      })

      if (!result.isConfirmed) return

      try {
        const res = await fetch((process.env.VUE_APP_URL || 'http://localhost:3000').replace(/\/+$/, '') + `/clients/${client.id}`, {
          method: 'DELETE',
          headers: {
            ...(localStorage.getItem('access_token')
              ? { Authorization: `Bearer ${JSON.parse(localStorage.getItem('access_token'))}` }
              : {}),
          },
        })
        const data = await res.json()
        if (data && data.status) {
          await loadClients()
          Swal.fire('Deleted', 'Client deleted successfully.', 'success')
        } else {
          console.error('Failed to delete client', data)
          Swal.fire('Error', 'Failed to delete client.', 'error')
        }
      } catch (err) {
        console.error('Failed to delete client', err)
        Swal.fire('Error', 'Failed to delete client.', 'error')
      }
    }


    onMounted(async () => {
      await Promise.all([loadClients(), loadSectors(), loadCountries()])
    })

    onBeforeUnmount(() => {
      if (dataTable) {
        dataTable.destroy()
        dataTable = null
      }
    })

    const addCountry = async () => {
      if (!newCountry.value.trim()) return
      try {
        const base = (process.env.VUE_APP_URL || 'http://localhost:3000').replace(/\/+$/, '')
        const res = await fetch(base + '/countries', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(localStorage.getItem('access_token')
              ? { Authorization: `Bearer ${JSON.parse(localStorage.getItem('access_token'))}` }
              : {}),
          },
          body: JSON.stringify({ name: newCountry.value.trim() }),
        })
        const data = await res.json()
        if (data && data.status) {
          form.country = data.data?.name || newCountry.value.trim()
          newCountry.value = ''
          await loadCountries()
        }
      } catch (err) {
        console.error('Failed to add country', err)
      }
    }

    // Filters state and functions
    const showFilters = ref(false)
    const filters = reactive({ search: '', country: '', sectorId: '', hasActive: '', minContracts: '', startDate: '', endDate: '' })

    const applyFilters = () => {
      const arr = originalClients.value || []
      const out = arr.filter(c => {
        if (filters.search) {
          const s = filters.search.toLowerCase()
          if (!((c.name || '').toLowerCase().includes(s))) return false
        }
        if (filters.country) {
          if ((c.country || '') !== filters.country) return false
        }
        if (filters.sectorId) {
          if ((c.sector && c.sector.id) != filters.sectorId) return false
        }
        if (filters.hasActive) {
          if (filters.hasActive === 'yes' && !c.hasActiveContract) return false
          if (filters.hasActive === 'no' && c.hasActiveContract) return false
        }
        if (filters.minContracts) {
          const min = Number(filters.minContracts) || 0
          if ((c.contractsCount || 0) < min) return false
        }
        if (filters.startDate) {
          if (!c.createdAt) return false
          if (new Date(c.createdAt) < new Date(filters.startDate)) return false
        }
        if (filters.endDate) {
          if (!c.createdAt) return false
          const end = new Date(filters.endDate); end.setHours(23,59,59,999)
          if (new Date(c.createdAt) > end) return false
        }
        return true
      })

      clients.value = out
      setTimeout(() => { if (dataTable) { dataTable.destroy(); dataTable = null } initializeDataTable() }, 50)
    }

    const resetFilters = () => {
      filters.search = ''
      filters.country = ''
      filters.sectorId = ''
      filters.hasActive = ''
      filters.minContracts = ''
      filters.startDate = ''
      filters.endDate = ''
      clients.value = originalClients.value || []
      setTimeout(() => { if (dataTable) { dataTable.destroy(); dataTable = null } initializeDataTable() }, 50)
    }

    const totalClients = computed(() => clients.value.length)
    const totalOpportunities = computed(() =>
      clients.value.reduce((sum, c) => sum + (c.opportunitiesCount || 0), 0),
    )
    const totalContracts = computed(() =>
      clients.value.reduce((sum, c) => sum + (c.contractsCount || 0), 0),
    )
    const clientsWithActiveContract = computed(
      () => clients.value.filter((c) => c.hasActiveContract).length,
    )

    return {
      clients,
      saving,
      loading,
      countries,
      sectors,
      form,
      clientsTable,
      showAddForm,
      showFilters,
      filters,
      applyFilters,
      resetFilters,
      loadClients,
      loadCountries,
      loadSectors,
      saveClient,
      deleteClient,
      newCountry,
      addCountry,
      editing,
      startEdit,
      totalClients,
      totalOpportunities,
      totalContracts,
      clientsWithActiveContract,
    }
  },
}
</script>

<style scoped>
.card {
  border-radius: 8px;
}

.bd-btn-scale {
  font-size: 11px;
  padding: 2px 8px;
  line-height: 1.4;
}

.transaction-products-list { background: transparent; padding: 15px; border-radius: 0 }
</style>
